import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
const useSendAlert = () => {
  const notyf = new Notyf({
    duration: 10000,
    position: {
      x: 'right',
      y: 'top'
    },
    types: [
      {
        type: 'warning',
        background: 'orange',
        icon: {
          className: 'material-icons',
          tagName: 'i'
        }
      }
    ]
  });
  const customStyles = document.createElement('style');
  customStyles.innerHTML = `
 .notyf {
      padding: 10px;
    }
    .notyf .notyf__message {
      font-size: 16px; 
    }
  `;
  document.head.appendChild(customStyles);
  return (message, type = 'success') => {
    if (type === 'success') {
      notyf.success({ message, dismissible: false });
    } else if (type === 'error') {
      notyf.error(message);
    } else {
      notyf.open({
        type: 'warning',
        message
      });
    }
  };
};

export { useSendAlert };
